// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"472":"faf614c8","926":"0af313e8"}[chunkId] + ".chunk.js";
};